
import { supabase } from "@/integrations/supabase/client";

export interface BucketInfo {
  id: string;
  name: string;
  public: boolean;
}

// Predefined list of known storage buckets
const KNOWN_BUCKETS: BucketInfo[] = [
  { id: 'episode-thumbnails', name: 'episode-thumbnails', public: true },
  { id: 'character-images', name: 'character-images', public: true },
  { id: 'partner-logos', name: 'partner-logos', public: true },
  { id: 'activities', name: 'activities', public: true },
];

export const discoverStorageBuckets = async (): Promise<BucketInfo[]> => {
  console.log('Using predefined bucket list instead of API discovery');
  
  // Validate that buckets exist by attempting to list files
  const validBuckets: BucketInfo[] = [];
  
  for (const bucket of KNOWN_BUCKETS) {
    try {
      const { data, error } = await supabase.storage
        .from(bucket.name)
        .list('', { limit: 1 });
      
      if (!error) {
        validBuckets.push(bucket);
        console.log(`Bucket ${bucket.name} is accessible`);
      } else {
        console.warn(`Bucket ${bucket.name} may not exist or is not accessible:`, error.message);
      }
    } catch (error) {
      console.warn(`Failed to verify bucket ${bucket.name}:`, error);
    }
  }
  
  return validBuckets;
};

export const getBucketFileStructure = async (bucketName: string) => {
  try {
    // First try to list files in the root of the bucket
    const { data: rootFiles, error: rootError } = await supabase.storage
      .from(bucketName)
      .list('', { limit: 100 });

    if (rootError) {
      console.error(`Error listing root files in ${bucketName}:`, rootError);
      return { rootFiles: [], subfolderFiles: [], structure: 'error' };
    }

    // Also try to list files in a subfolder with the bucket name (legacy structure)
    const { data: subfolderFiles, error: subfolderError } = await supabase.storage
      .from(bucketName)
      .list(bucketName, { limit: 100 });

    const structure = rootFiles?.length > 0 ? 'root' : subfolderFiles?.length > 0 ? 'subfolder' : 'empty';
    
    console.log(`Bucket ${bucketName} structure:`, {
      rootFiles: rootFiles?.length || 0,
      subfolderFiles: subfolderFiles?.length || 0,
      structure
    });

    return {
      rootFiles: rootFiles || [],
      subfolderFiles: subfolderFiles || [],
      structure
    };
  } catch (error) {
    console.error(`Failed to analyze bucket structure for ${bucketName}:`, error);
    return { rootFiles: [], subfolderFiles: [], structure: 'error' };
  }
};
